export const INSTAGRAM = {
	handle: '@framesbybhagya',
	url: 'https://www.instagram.com/framesbybhagya',
	bio: 'Artist. Pune Photographer. Inspired by real life, real people & light. Love what I do — seeing the extraordinary in the ordinary.',
};